import { z } from 'zod';

export type SiteSeparationRuleId = string;

export interface SiteSeparationRuleCommon {
  id: SiteSeparationRuleId;
  note: string;
}

export const siteSeparationRuleCommonSchemaZ = z.object({
  id: z.string().nonempty().uuid(),
  note: z.string(),
});
